import React from 'react'
import { Box, Grid } from '@mui/material'
import PointTransactionCard from '../../../../components/leaderboard/pointTransaction/PointTransactionCard'
import PointTransactionTable from '../../../../components/leaderboard/pointTransaction/PointTransactionTable'
import useAppUtilities from '../../../../hooks/useAppUtilities'

const PointTransactionTab: React.FC = () => {
  const { theme } = useAppUtilities()
  const data = [
    {
      image: 'coin-yellow',
      coin: 12580,
      subtitle: 'Total points earned ',
    },

    {
      image: 'coin-blue',
      coin: 4.3,
      subtitle: 'Total Points Spent',
    },
    {
      image: 'coin-success',
      coin: 1806,
      subtitle: 'Total points remaining ',
    },
  ]

  const actions = [
    { date: '02 February 2025', action: 'Invited a restaurant', points: '+10' },
    { date: '03 March 2025', action: 'Invited an influencer', points: '+10' },
    { date: '04 April 2025', action: 'Invited a eater', points: '+10' },
    { date: '05 May 2025', action: 'Purchased a coupon', points: '-120 ' },
    { date: '10 October 2025', action: 'Invited a eater', points: '+10' },
    { date: '06 June 2025', action: 'Invited a eater', points: '+10' },
    { date: '09 September 2025', action: 'Invited a eater', points: '+10' },
    { date: '07 July 2025', action: 'Invited a eater', points: '+10' },
    { date: '08 August 2025', action: 'Purchased a coupon', points: '-80' },
    { date: '01 January 2025', action: 'Purchased a coupon', points: '-80' },
    { date: '01 January 2025', action: 'Purchased a coupon', points: '-80' },
    { date: '01 January 2025', action: 'Purchased a coupon', points: '-80' },
    { date: '01 January 2025', action: 'Purchased a coupon', points: '-80' },
  ]
  return (
    <Box mt={2} sx={{ flex: 1, overflowY: 'auto', height: '100%' }}>
      <Box>
        <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
          {data.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <PointTransactionCard data={item} />
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box mt={2} pb={{ xs: 2, md: 0 }}>
        <PointTransactionTable
          pointList={actions}
          maxHeight={theme.breakpoints.up('md') ? 400 : 200}
        />
      </Box>
    </Box>
  )
}

export default PointTransactionTab
